<template>
  <div class="modal pb-8">
    <div class="close cursor-pointer text-right pt-5 pr-5">
      <iconClose @click="$emit('close')"/>
    </div>
    <img class="icon mb-5" src="~@/static/custom-img/wait.png" alt="">
    <div class="modal-title mb-5">{{ $t('onboardingSpecial.downgradeModal.title') }}</div>
    <div class="text mb-5">
      {{ $t('onboardingSpecial.downgradeModal.descriptionP1') }}
      <br/>
      {{ $t('onboardingSpecial.downgradeModal.descriptionP2') }}
    </div>
    <div class="question">{{ $t('onboardingSpecial.downgradeModal.question') }}</div>
    <div>
      <text-field
        v-model="answer"
        name="Answer"
        type="text"
        tag="div"
        class="input"
        :placeholder="$t('onboardingSpecial.downgradeModal.placeholder')"
      >
      </text-field>
    </div>
    <loaderButton
      className="apply-btn btn btn--sm btn--warmPink mb-5"
      @click.stop.prevent="apply"
      :loading="loading"
    >
      <div>{{ $t('onboardingSpecial.downgradeModal.apply') }} </div>
      <div class="small">{{ $t('onboardingSpecial.downgradeModal.smallApply') }}</div>
    </loaderButton>
    <div @click="$emit('cancel')" class="link no">{{ $t('onboardingSpecial.downgradeModal.no') }}</div>
  </div>
</template>

<script>
import textField from '@/components/base/textField';
import loaderButton from '@/components/base/loaderButton';
import iconClose from '@/static/custom-img/close.svg';

export default {
  components: {
    textField,
    iconClose,
    loaderButton,
  },

  data () {
    return {
      answer: '',
      loading: false,
    };
  },

  methods: {
    async apply () {
      this.loading = true;
      await new Promise((resolve) => {
        setTimeout(resolve, 1000);
      });
      this.loading = false;

      this.$emit('apply');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  padding-top: 30px;
  text-align: center;
  background-image: url('~@/static/custom-img/how.png');
  background-size: 117px;
  background-position: 100% 100%;
}

.close {
  position: absolute;
  top: 0px;
  right: 0px;
}

.icon {
  width: 90px;
  height: 90px;
}

.modal-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
  width: 350px;
  padding: 9px 0;
  margin: auto;
  background-image: url('~@/static/custom-img/modalTitle.png');
  background-size: 100%;
}

.text {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
  width: 285px;
  margin: auto;
}

.question {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
  width: 215px;
  margin: auto;

}

.link {
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #FA507B;
  width: 150px;
  margin: auto;
  cursor: pointer;
  text-decoration-line: underline;
}

.input {
  width: 300px;
  margin: auto;

  &::v-deep {
    ::-webkit-input-placeholder {
      text-align: center;
    }

    :-moz-placeholder { /* Firefox 18- */
      text-align: center;
    }

    ::-moz-placeholder {  /* Firefox 19+ */
      text-align: center;
    }

    :-ms-input-placeholder {
      text-align: center;
    }
  }
}

.apply-btn {
  width: 300px;
  font-weight: bold;
  font-size: 18px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.175px;
  color: #FFFFFF;
  padding: 14px;

  .small {
    font-size: 12px;
    font-weight: normal;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .modal {
    padding-bottom: 45px!important;
    background-size: 80px;
    background-position: 100% 100%;
  }

  .icon {
    width: 75px;
    height: 75px;
  }
  .modal-title {
    font-size: 14px;
    line-height: 11px;
    width: 255px;
  }

  .text {
    font-size: 12px;
    line-height: 16px;
    width: 255px;
  }

  .input {
    width: 240px;
  }

  .apply-btn {
    width: 240px;
  }
}
</style>
